import Config from "./config";
import State from "./state";
import axios from 'axios';
import {Sha256} from "clariant-helpers-vue3";

var DataLayer = {
    getProducts() {
        let url = `${Config.wsUrl}/products?bl=${Config.businessLineId}`;
        return axios.get(url);
    },
    getEcolabelInfo() {
        let url = `${Config.wsUrl}/labels`;
        return axios.get(url);
    },
    computeSignature(params) {
        if (!params) return "";
        var sha = Sha256(`${params.userId}||${params.ecolabels}`);
        return sha;
    },
    getCookieValue(name) {
        var res = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(name).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
        if (res) return res;
        else return "";
    },
    getFunctionLabel(id) {
        if (!id || State.filters.functions == 0) return "";
        let val = State.filters.functions.find(f => { return f.id === id });
        return val ? val.name : "";
    },
    getEcolabels(ids) {
        let ret = [];
        if (State.filters.ecolabels == 0) return "";
        State.filters.ecolabels.map(e => {
            if (ids.indexOf(e.id) !== -1) {ret.push(e.name);}
        });
        return ret.join("|");
    },
    recordFilters(filters) {
        if (!filters) return;
        if(!State.filters) return;
        let params = {
            id: 0,
            userId: this.getCookieValue("CLAUserID"),
            function: this.getFunctionLabel(filters.function),
            ecolabels: this.getEcolabels(filters.ecolabels),
            rci: `${filters.rci[0]} - ${filters.rci[1]}`,
            ewg: `${filters.ewg[0]} - ${filters.ewg[1]}`,
            productCount: document.querySelectorAll(".egt .results-container .product-entry").length,
            blId: Config.businessLineId
        };
        params.signature = this.computeSignature(params);
        let url = `${Config.wsUrl}/filters`;
        return axios.post(url, params);
    },
    recordProduct(product, filters) {
        if (!product) return;
        let params = {
            id: 0,
            userId: this.getCookieValue("CLAUserID"),
            function: this.getFunctionLabel(filters.function),
            ecolabels: this.getEcolabels(filters.ecolabels),
            rci: `${filters.rci[0]} - ${filters.rci[1]}`,
            ewg: `${filters.ewg[0]} - ${filters.ewg[1]}`,
            productId: product.id,
            productName: product.title,
            productUrl: product.url,
            blId: Config.businessLineId
        };
        params.signature = this.computeSignature(params);
        let url = `${Config.wsUrl}/product`;
        return axios.post(url, params);
    },
    constructFilterMap(filters) {
        this.state.filterMap = [];
        if (!filters) return;
        filters.map((filter) => {
            filter.options.map((opt) => {
                this.state.filterMap.push({id: opt.id, name: opt.name});
            });
        });
    }
};

export default DataLayer;